{
  "REPORT": {
    "HEADER": "שיחות",
    "LOADING_CHART": "טוען נתוני תרשים...",
    "NO_ENOUGH_DATA": "לא קיבלנו מספיק נקודות נתונים כדי להפיק דוח, אנא נסה שוב מאוחר יותר.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "אחזור הנתונים נכשל, אנא נסה שוב מאוחר יותר.",
    "SUMMARY_FETCHING_FAILED": "אחזור הסיכום נכשל, אנא נסה שוב מאוחר יותר.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "שיחות",
        "DESC": "( סך הכל )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "הודעות נכנסות",
        "DESC": "( סך הכל )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "הודעות יוצאות",
        "DESC": "( סך הכל )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "זמן תגובה ראשון",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן התגובה הראשון הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_TIME": {
        "NAME": "זמן רזולוציה",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן הרזולוציה הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "ספירת רזולוציות",
        "DESC": "( סך הכל )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "ספירת רזולוציות",
        "DESC": "( סך הכל )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "ספירת העברות",
        "DESC": "( סך הכל )"
      },
      "REPLY_TIME": {
        "NAME": "זמן המתנת לקוח",
        "TOOLTIP_TEXT": "זמן ההמתנה הוא {metricValue} (מבוסס על {conversationCount} תגובות)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "7 הימים האחרונים",
      "LAST_14_DAYS": "14 הימים האחרונים",
      "LAST_30_DAYS": "30 הימים האחרונים",
      "THIS_MONTH": "החודש",
      "LAST_MONTH": "חודש שעבר",
      "LAST_3_MONTHS": "3 החודשים האחרונים",
      "LAST_6_MONTHS": "6 החודשים האחרונים",
      "LAST_YEAR": "שנה שעברה",
      "CUSTOM_DATE_RANGE": "טווח תאריכים מותאם אישית"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "להגיש מועמדות",
      "PLACEHOLDER": "בחר טווח תאריכים"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "קבוצה לפי",
    "DURATION_FILTER_LABEL": "משך",
    "GROUPING_OPTIONS": {
      "DAY": "יום",
      "WEEK": "שבוע",
      "MONTH": "חודש",
      "YEAR": "שנה"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "יום"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "יום"
      },
      {
        "id": 2,
        "groupBy": "שבוע"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "יום"
      },
      {
        "id": 2,
        "groupBy": "שבוע"
      },
      {
        "id": 3,
        "groupBy": "חודש"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "יום"
      },
      {
        "id": 2,
        "groupBy": "שבוע"
      },
      {
        "id": 3,
        "groupBy": "חודש"
      }
    ],
    "BUSINESS_HOURS": "שעות פעילות",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "נקה מסנן",
      "EMPTY_LIST": "לא נמצאו תוצאות"
    },
    "PAGINATION": {
      "RESULTS": "מציג {start} עד {end} מתוך {total} תוצאות",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "סקירה כללית של סוכנים",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "טוען נתוני תרשים...",
    "NO_ENOUGH_DATA": "לא קיבלנו מספיק נקודות נתונים כדי להפיק דוח, אנא נסה שוב מאוחר יותר.",
    "DOWNLOAD_AGENT_REPORTS": "הורד דוחות סוכן",
    "FILTER_DROPDOWN_LABEL": "בחר סוכן",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "חפש סוכנים"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "שיחות",
        "DESC": "( סך הכל )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "הודעות נכנסות",
        "DESC": "( סך הכל )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "הודעות יוצאות",
        "DESC": "( סך הכל )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "זמן תגובה ראשון",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן התגובה הראשון הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_TIME": {
        "NAME": "זמן רזולוציה",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן הרזולוציה הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "ספירת רזולוציות",
        "DESC": "( סך הכל )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 הימים האחרונים"
      },
      {
        "id": 1,
        "name": "30 הימים האחרונים"
      },
      {
        "id": 2,
        "name": "3 החודשים האחרונים"
      },
      {
        "id": 3,
        "name": "6 החודשים האחרונים"
      },
      {
        "id": 4,
        "name": "שנה שעברה"
      },
      {
        "id": 5,
        "name": "טווח תאריכים מותאם אישית"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "להגיש מועמדות",
      "PLACEHOLDER": "בחר טווח תאריכים"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "סקירת תוויות",
    "DESCRIPTION": "עקוב אחר ביצועי התוויות עם מדדי מפתח כולל שיחות, זמני תגובה, זמני סגירה ומקרים שנסגרו. לחץ על שם תווית לקבלת תובנות מפורטות.",
    "LOADING_CHART": "טוען נתוני תרשים...",
    "NO_ENOUGH_DATA": "לא קיבלנו מספיק נקודות נתונים כדי להפיק דוח, אנא נסה שוב מאוחר יותר.",
    "DOWNLOAD_LABEL_REPORTS": "הורד דוחות תווית",
    "FILTER_DROPDOWN_LABEL": "בחר תווית",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "חפש תוויות"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "שיחות",
        "DESC": "( סך הכל )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "הודעות נכנסות",
        "DESC": "( סך הכל )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "הודעות יוצאות",
        "DESC": "( סך הכל )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "זמן תגובה ראשון",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן התגובה הראשון הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_TIME": {
        "NAME": "זמן רזולוציה",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן הרזולוציה הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "ספירת רזולוציות",
        "DESC": "( סך הכל )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 הימים האחרונים"
      },
      {
        "id": 1,
        "name": "30 הימים האחרונים"
      },
      {
        "id": 2,
        "name": "3 החודשים האחרונים"
      },
      {
        "id": 3,
        "name": "6 החודשים האחרונים"
      },
      {
        "id": 4,
        "name": "שנה שעברה"
      },
      {
        "id": 5,
        "name": "טווח תאריכים מותאם אישית"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "להגיש מועמדות",
      "PLACEHOLDER": "בחר טווח תאריכים"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "סקירה כללית של תיבת הדואר הנכנס",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "טוען נתוני תרשים...",
    "NO_ENOUGH_DATA": "לא קיבלנו מספיק נקודות נתונים כדי להפיק דוח, אנא נסה שוב מאוחר יותר.",
    "DOWNLOAD_INBOX_REPORTS": "הורד דוחות תיבת דואר נכנס",
    "FILTER_DROPDOWN_LABEL": "בחר תיבת דואר",
    "ALL_INBOXES": "כל תיבות הדואר הנכנס",
    "SEARCH_INBOX": "חפש תיבת דואר נכנס",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "שיחות",
        "DESC": "( סך הכל )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "הודעות נכנסות",
        "DESC": "( סך הכל )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "הודעות יוצאות",
        "DESC": "( סך הכל )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "זמן תגובה ראשון",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן התגובה הראשון הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_TIME": {
        "NAME": "זמן רזולוציה",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן הרזולוציה הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "ספירת רזולוציות",
        "DESC": "( סך הכל )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 הימים האחרונים"
      },
      {
        "id": 1,
        "name": "30 הימים האחרונים"
      },
      {
        "id": 2,
        "name": "3 החודשים האחרונים"
      },
      {
        "id": 3,
        "name": "6 החודשים האחרונים"
      },
      {
        "id": 4,
        "name": "שנה שעברה"
      },
      {
        "id": 5,
        "name": "טווח תאריכים מותאם אישית"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "להגיש מועמדות",
      "PLACEHOLDER": "בחר טווח תאריכים"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "סקירת צוות",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "טוען נתוני תרשים...",
    "NO_ENOUGH_DATA": "לא קיבלנו מספיק נקודות נתונים כדי להפיק דוח, אנא נסה שוב מאוחר יותר.",
    "DOWNLOAD_TEAM_REPORTS": "הורד דוחות צוות",
    "FILTER_DROPDOWN_LABEL": "תבחר קבוצה",
    "FILTERS": {
      "ADD_FILTER": "הוסף מסנן",
      "CLEAR_ALL": "נקה הכל",
      "NO_FILTER": "אין מסננים זמינים",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "חפש צוותים"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "שיחות",
        "DESC": "( סך הכל )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "הודעות נכנסות",
        "DESC": "( סך הכל )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "הודעות יוצאות",
        "DESC": "( סך הכל )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "זמן תגובה ראשון",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן התגובה הראשון הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_TIME": {
        "NAME": "זמן רזולוציה",
        "DESC": "( ממוצע )",
        "INFO_TEXT": "מספר כולל של שיחות המשמשות לחישוב:",
        "TOOLTIP_TEXT": "זמן הרזולוציה הוא {metricValue} (מבוסס על {conversationCount} שיחות)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "ספירת רזולוציות",
        "DESC": "( סך הכל )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 הימים האחרונים"
      },
      {
        "id": 1,
        "name": "30 הימים האחרונים"
      },
      {
        "id": 2,
        "name": "3 החודשים האחרונים"
      },
      {
        "id": 3,
        "name": "6 החודשים האחרונים"
      },
      {
        "id": 4,
        "name": "שנה שעברה"
      },
      {
        "id": 5,
        "name": "טווח תאריכים מותאם אישית"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "להגיש מועמדות",
      "PLACEHOLDER": "בחר טווח תאריכים"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "דוחות CSAT",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "הורד דוחות CSAT",
    "DOWNLOAD_FAILED": "הורדת דוחות CSAT נכשלה",
    "FILTERS": {
      "ADD_FILTER": "הוסף מסנן",
      "CLEAR_ALL": "נקה הכל",
      "NO_FILTER": "אין מסננים זמינים",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "חפש סוכנים",
        "INBOXES": "Search inboxes",
        "TEAMS": "חפש צוותים",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "סוכן"
      },
      "INBOXES": {
        "LABEL": "תיבת הדואר הנכנס"
      },
      "TEAMS": {
        "LABEL": "צוות"
      },
      "RATINGS": {
        "LABEL": "דירוג"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "איש קשר",
        "AGENT_NAME": "סוכן",
        "RATING": "דירוג",
        "FEEDBACK_TEXT": "הערת משוב",
        "CONVERSATION": "שיחה",
        "CUSTOMER": "Customer",
        "RESPONSE": "תגובה",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "סה\"כ תגובות",
        "TOOLTIP": "מספר כולל של תגובות שנאספו"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "ציון שביעות רצון",
        "TOOLTIP": "מספר סה\"כ של תגובות חיוביות / סה\"כ מספר תגובות * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "שיעור תגובה",
        "TOOLTIP": "מספר כולל של תגובות / מספר כולל של הודעות סקר CSAT שנשלחו * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "שמור",
      "CANCEL": "ביטול",
      "SAVING": "שומר...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "שדרג עכשיו",
        "CANCEL_ANYTIME": "תוכל לשנות או לבטל את התוכנית שלך בכל עת"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "דוחות בוט",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "מספר שיחות",
        "TOOLTIP": "המספר הכולל של השיחות שטופלו על ידי הבוט"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "סך התגובות",
        "TOOLTIP": "המספר הכולל של התגובות שנשלחו על ידי הבוט"
      },
      "RESOLUTION_RATE": {
        "LABEL": "שיעור סגירה",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "שיעור העברה",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "סקירה כללית",
    "LIVE": "לחיות",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "שיחות פתוחות",
      "LOADING_MESSAGE": "טוען מדדי שיחה...",
      "OPEN": "פתח",
      "UNATTENDED": "ללא השגחה",
      "UNASSIGNED": "לא הוקצתה",
      "PENDING": "ממתין ל"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "תנועת שיחות",
      "NO_CONVERSATIONS": "בלי שיחות",
      "CONVERSATION": "שיחה {count}",
      "CONVERSATIONS": "{count} שיחות",
      "DOWNLOAD_REPORT": "הורד דוח"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "סגירות",
      "NO_CONVERSATIONS": "בלי שיחות",
      "CONVERSATION": "שיחה {count}",
      "CONVERSATIONS": "{count} שיחות",
      "DOWNLOAD_REPORT": "הורד דוח"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "שיחות של סוכנים",
      "LOADING_MESSAGE": "מדדי סוכן טעינה...",
      "NO_AGENTS": "אין שיחות של סוכנים",
      "TABLE_HEADER": {
        "AGENT": "סוכן",
        "OPEN": "פתח",
        "UNATTENDED": "ללא השגחה",
        "STATUS": "מצב"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "כל הצוותים",
      "HEADER": "שיחות לפי צוותים",
      "LOADING_MESSAGE": "טוען מדדי צוות...",
      "NO_TEAMS": "אין נתונים זמינים",
      "TABLE_HEADER": {
        "TEAM": "צוות",
        "OPEN": "פתח",
        "UNATTENDED": "ללא השגחה",
        "STATUS": "מצב"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "סטטוס סוכן",
      "ONLINE": "מחובר",
      "BUSY": "עסוק",
      "OFFLINE": "לא מחובר"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "יום ראשון",
    "MONDAY": "יום שני",
    "TUESDAY": "יום שלישי",
    "WEDNESDAY": "יום רביעי",
    "THURSDAY": "יום חמישי",
    "FRIDAY": "שישי",
    "SATURDAY": "יום שבת"
  },
  "SLA_REPORTS": {
    "HEADER": "דוחות SLA",
    "NO_RECORDS": "שיחות שהוחל עליהן SLA אינן זמינות.",
    "LOADING": "טוען נתוני SLA...",
    "DOWNLOAD_SLA_REPORTS": "הורד דוחות SLA",
    "DOWNLOAD_FAILED": "הורדת דוחות SLA נכשלה",
    "DROPDOWN": {
      "ADD_FIlTER": "הוסף מסנן",
      "CLEAR_ALL": "נקה הכל",
      "CLEAR_FILTER": "נקה מסנן",
      "EMPTY_LIST": "לא נמצאו תוצאות",
      "NO_FILTER": "אין מסננים זמינים",
      "SEARCH": "חפש מסנן",
      "INPUT_PLACEHOLDER": {
        "SLA": "שם SLA",
        "AGENTS": "שם סוכן",
        "INBOXES": "שם תיבת דואר נכנס",
        "LABELS": "שם התווית",
        "TEAMS": "שם קבוצה"
      },
      "SLA": "מדיניות SLA",
      "INBOXES": "תיבת הדואר הנכנס",
      "AGENTS": "סוכן",
      "LABELS": "תווית",
      "TEAMS": "צוות"
    },
    "WITH": "עם",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "שיעור עמידה",
        "TOOLTIP": "אחוז ה-SLA שנוצרו והושלמו בהצלחה"
      },
      "NO_OF_MISSES": {
        "LABEL": "מספר החמצות",
        "TOOLTIP": "סך החמצות SLA בתקופה מסוימת"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "מספר שיחות",
        "TOOLTIP": "המספר הכולל של שיחות עם SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "מדיניות",
        "CONVERSATION": "שיחה",
        "AGENT": "סוכן"
      },
      "VIEW_DETAILS": "הצג פרטים"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "תיבת הדואר הנכנס",
    "AGENT": "סוכן",
    "TEAM": "צוות",
    "LABEL": "תווית",
    "AVG_RESOLUTION_TIME": "זמן סגירה ממוצע",
    "AVG_FIRST_RESPONSE_TIME": "זמן תגובה ראשונה ממוצע",
    "AVG_REPLY_TIME": "זמן המתנת לקוח ממוצע",
    "RESOLUTION_COUNT": "ספירת רזולוציות",
    "CONVERSATIONS": "מספר שיחות"
  }
}
